import React from "react"
import PropTypes from "prop-types"
import CircularNavButton from "../components/circularNavButton"
import NavButton from "../components/navButton"
import Box from "@material-ui/core/Box"
import Grid from "@material-ui/core/Grid"

const BannerNav = ({
  boxText,
  boxLink,
  boxId,
  circularText,
  circularLink,
  circularId,
  colorClass,
}) => {
  return (
    <Box className="nav-banner" mt={5}>
      <Grid container wrap="wrap" alignItems="center" spacing={3}>
        <Grid item>
          <NavButton
            text={boxText}
            link={boxLink}
            className={colorClass}
            id={boxId}
          ></NavButton>
        </Grid>
        <Grid item>
          <CircularNavButton
            text={circularText}
            link={circularLink}
            className={colorClass}
            id={circularId}
          ></CircularNavButton>
        </Grid>
      </Grid>
    </Box>
  )
}

BannerNav.propTypes = {
  boxText: PropTypes.string,
  boxLink: PropTypes.string,
  colorClass: PropTypes.string,
  circularText: PropTypes.string,
  circularLink: PropTypes.string,
  boxId: PropTypes.string,
  circularId: PropTypes.string,
}

BannerNav.defaultProps = {
  boxText: ``,
  boxLink: `/`,
  colorClass: `primary`,
  circularText: ``,
  circularLink: `/`,
  boxId: ``,
  circularId: ``,
}

export default BannerNav
